import { Table, Tooltip } from 'antd';
import { difference } from 'lodash-es';

import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';
import { COLUMN_NAME_WIDTH } from 'lib/styles/number';

import { baseConditionInit } from '../fields/behavior';

import { FieldsTableType } from './type';

import styles from './FieldsTable.module.less';

const cx = classnames(styles);
const FieldsTable: React.FC<FieldsTableType> = ({ fieldsData, selectedKeys, setSelectedKeys }) => {
  const { t } = useI18n();

  const columns = [
    {
      title: t('pages.fieldBehavior.default.fieldsName'),
      dataIndex: 'field',
      key: 'field',
      width: COLUMN_NAME_WIDTH,
      ellipsis: {
        showTitle: false,
      },
      render: text => {
        let result: React.ReactNode | string = '';
        if (text?.objectId) {
          result = text.name;
        } else {
          result = <div className={cx('del-field')}>{t('pages.fieldBehavior.default.delField')}</div>;
        }
        return (
          <Tooltip placement="top" title={result}>
            {result}
          </Tooltip>
        );
      },
    },
    {
      title: t('pages.fieldBehavior.columns.default'),
      dataIndex: 'default',
      key: 'default',
      render: text => {
        if (text) {
          return baseConditionInit(text);
        }
        return '';
      },
    },
    {
      title: t('pages.fieldBehavior.columns.behaviorCount'),
      dataIndex: 'behaviorCount',
      key: 'behaviorCount',
      render: (text, record) => {
        return text || record.behavior?.length || 0;
      },
    },
    {
      title: t('pages.fieldBehavior.columns.cascadeCount'),
      dataIndex: 'cascadeCount',
      key: 'cascadeCount',
      render: (text, record) => {
        return text || record.cascade?.length || 0;
      },
    },
  ];

  const rowSelection = {
    onSelect: (record, selected) => {
      setSelectedKeys(prev => {
        let current = [...prev];
        if (selected) {
          current.push(record.objectId);
        } else {
          current = current.filter(objectId => objectId !== record.objectId);
        }
        return current;
      });
    },
    onSelectAll: (selected, _, changeRows) => {
      const selectedRowsKeys = changeRows.map(row => row.objectId);
      setSelectedKeys(prev => {
        return selected ? [...prev, ...selectedRowsKeys] : difference(prev, selectedRowsKeys);
      });
    },
    selectedRowKeys: selectedKeys,
    getCheckboxProps: record => ({
      disabled: !record?.field?.objectId,
    }),
  };

  return (
    <div className={cx('field-wrapper', 'behavior-list')}>
      <div className={cx('field-header')}>{t('pages.fieldBehavior.batch.chooseNeedEditField')}</div>
      <Table
        dataSource={fieldsData}
        rowKey="objectId"
        pagination={false}
        columns={columns}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        scroll={{ y: 'calc(100% - 50px)' }}
      />
    </div>
  );
};

export default FieldsTable;
